module.exports = __webpack_public_path__ + "n.no1.65cb4826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/n.no1.jpg
// module id = UXxX
// module chunks = 0